import DapDSTray from './tray.component'

export * from './tray.component'
export default DapDSTray

DapDSTray.define()

declare global {
  interface HTMLElementTagNameMap {
    'dap-ds-tray': DapDSTray
  }
}
